// extracted by mini-css-extract-plugin
module.exports = {"toggleFavorite":"FavoriteButton_toggleFavorite__1PG1v"};